module.exports = __webpack_public_path__ + "static/img/right_pre.759c4ddb.png";